import React, { useContext } from 'react';
import { xs_languageCode } from '../..';
import LiveContext from '../../contexts/LiveContext';
import MainContext from '../../contexts/MainContext';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import FastbetCartContext from '../../data/fastbet/FastbetCartContext';
import { oddToString, getConfiguration, getPrematchAggs, formatDate, getSplitDesc } from '../../data/utils';
import { getLabel } from '../../InitData';
import AmountBetslipForm from './AmountBetslipForm';

function EventCoupon(props) {
	const betslipContext = useContext(BetslipContext) ;
	const betslipData = betslipContext.getBetslipData();
	const fastbetContext = useContext(FastbetCartContext);
	const liveContext = useContext(LiveContext);
	const mainContext = useContext(MainContext);
	const couponKey = props.couponKey;
	const conf = getConfiguration();
	const bankerEnabled = conf.sybe != null? conf.sybe : true;
	const showSelectionTimestamp = conf?.sbst;
    let alias = props.selection.alias;
    alias = alias == null? '' : alias + ' ';
    const container = props.container;
    let tabSingle = container === 'singlebets';
    let tabMulti = container === 'multibets';
    
    let event = props.selection;
	let eventTimestamp;

	if(showSelectionTimestamp) {
		try {
			eventTimestamp = event.timestamp && formatDate(event.timestamp).formatted;
		}catch(err){
			console.log(err);
		}
	}

    
    let descSportTournament = null;
    if(props.selection.descSport != null && props.selection.descSport.length > 0){
    	descSportTournament = props.selection.descSport;
    }
    
    if(props.selection.descTournament != null && props.selection.descTournament.length > 0){
    	if(descSportTournament == null){
    		descSportTournament = "";
    	}
    	else{
    		descSportTournament = descSportTournament + " - ";
    	}
    	descSportTournament =  descSportTournament + props.selection.descTournament;
    }
    
    let homeTeam = event.descEvent.split(" - ")[0];
    let awayTeam = event.descEvent.split(" - ")[1];
    
    let bets = event.bets;
    // restoring the bets array: if it is not a systembet, then I will draw just the first bet
    if(container != 'systembets' && !betslipContext.isBetBuilder()){
    	let aux = [];    
    	if(bets.length > 0){
    		aux.push(bets[0]);
    	}
    	bets = aux;
    }
    
   
    
    let idElement = "bet-event-coupon-" + couponKey + "-container-" + container + "-pal-" + event.pal + "-avv-" + event.avv;
    idElement = idElement + (tabSingle? "-for-bet-" + (bets[0].scomSogei + "-" + bets[0].handicap + "-" + bets[0].draw ) : "");
    function deleteSelection(scomSogei, handicap, codDraw, removeAllBets){
    	if(removeAllBets){
    		scomSogei = null;
    		codDraw = null;
    		handicap = null;
    	}
    	betslipContext.toggleSelectionBetslip(event.pal, event.avv, null, null, null, scomSogei, handicap, null, codDraw, null, null);
    }
    
    function toggleBanker(){
    	if(bankerEnabled){
        	event.banker = !event.banker;
        	betslipContext.setBetslipData(betslipData, true);
    	}

    }
    
 
    let blinkElement = false;
    if(event.closed == null || event.closed == false){
    	for(let km in event.bets){
    		blinkElement = blinkElement || (event.bets[km].updated != null || event.bets[km].closed); 
    	}
    }
    else{
    	blinkElement = true;
    }
    blinkElement = false; // TODO: check if we need another effect
    

    
    function openMatch(aliasToOpen){
    	if(betslipContext.isBetBuilder()){
    		return;
    	}
    	const aliasToSearch = aliasToOpen? aliasToOpen : alias.trim();
    	if(aliasToSearch.length > 0 && aliasToSearch !== '---'){
    		if(fastbetContext.isInitialized() == false){
    			fastbetContext.initialize(function(){
    				drawMatch();			
    			});
    		}
    		else{
    			drawMatch();
    		}
    	}
    }
    
    function drawMatch() {
    	if (event.isLive === false) {
    		const match = fastbetContext.prematchEventsByAlias[alias.trim()];
    		if (match) {
                const desc = match.dsl[xs_languageCode];
    			const [team1, team2] = getSplitDesc(desc);
				const aggr = getPrematchAggs(match.s, match.ag);
				const groupById = {};
				groupById[match.ag] = aggr;
    			const matchOpening = {
		            id: match.bid,
		            sportRef: match.s,
		            categoryRef: match.c,
		            tournamentRef: match.t,
		            pal: match.p,
		            avv: match.a,
		            desc,
		            team1,
		            team2,
		            sportDesc: match.dsml[xs_languageCode],
		            categoryDesc: match.dcml[xs_languageCode],
		            tournamentDesc: match.dtml[xs_languageCode],
		            alias: match.al,
		            uniqueId: `${match.s}_${match.c}_${match.t}_${match.bid}`,
		            gruppiScommessa: [{
		                idAggregata: match.ag
		            }],
		            gruppoById: groupById,
		            isLive : false,
		            openAggregata: match.ag,
		            openMacrogruppo: match.mc	
    			};
    			
    			mainContext.openPrematchEvent(matchOpening);
    		}
    	} else {
    		// live opening working in both sections (prematch and live) without any "section change"
    		const match = fastbetContext.liveEventsByAlias[alias.trim()];
    		if(match){
    	        liveContext.setMatchData({
    	            sportId: match.s,
    	            countryId: match.c,
    	            tournamentId: match.t,
    	            matchId: match.bid
    	        }, true);
    	        window.openSection('live-match');
    		}
    	}
    }

    return <>
		<div className={"evento-schedina" + (blinkElement? ' blink': '')} id={idElement}>
			<div className="grid-schedina grid-schedina-mobile grid-schedina-multipla">
			
				{event.closed != null && event.closed &&(
					<div className="eventClosed">{getLabel('carrello.event.event_closed')}</div>
					)
				}				
				<div className="grid-schedina-intestazione">
					<div className="grid-schedina-intestazione_contenitore-testo">
						{descSportTournament != null && (
								<p title={descSportTournament}>{descSportTournament}</p>                                    			
						)}
					</div>
		
					<div className="grid-schedina-intestazione_container-bottoni">
						
						{event.isLive &&(
							<div className="grid-schedina_bottone-live">
								<p>Live</p>
							</div>
							)
						}
						
						{container === 'systembets' && bankerEnabled && (
							<label className="custom-switch-2">
								<input checked={event.banker} onChange={(e) => toggleBanker()} type="checkbox" />
								<div className="custom-switch-2-text">{getLabel('systembet.fixed_char')}</div>
								<span className="custom-slider-2 round"></span>
							</label>
							)
						}
						<button className="grid-schedina_bottone-generico"
								onClick={() => {
									if(tabSingle  || betslipContext.isBetBuilder() || (tabMulti && event.bets[0].legabile)){
										const bet = event.bets[0];
										deleteSelection(bet.scomSogei, bet.handicap, bet.draw, false);	
									}
									else{
										deleteSelection(null, null, null, true);		
									}
								}
						}>
							<i className="fas fa-trash-alt fa-lg"></i>
						</button>
					</div>
				</div>
				{eventTimestamp && 
							<div className="grid-schedina-body_evento_nome-squadra">
								<p>{!conf.iwh && eventTimestamp}</p>
							</div>
				}
				<div className={"grid-schedina-body" + (event.closed != null && event.closed? " opacityEventClosed":"") }>
					
					<div className={"grid-schedina-body_evento"  + (alias.length > 0 && !betslipContext.isBetBuilder()? ' pointer' : '')} onClick={()=> openMatch()}>
						{
							!betslipContext.isBetBuilder() &&
							<div className="grid-schedina-body_evento_alias">
								<p>{alias}</p>
							</div>
						}
						<div className="grid-schedina-body_evento_nome-squadra">
							<p>{homeTeam}</p>
						</div>
						{awayTeam != null &&<>
							<div className="grid-schedina-body_evento_separatore">
								<p>-</p>
							</div>
							<div className="grid-schedina-body_evento_nome-squadra">
								<p>{awayTeam}</p>
							</div>
							</>
						}
					</div>
			
					<div className="grid-schedina-body_quote">
						{
							bets.map(function(bet){
								
								let reactKey =  "key bet-draw-sel-" + 
												couponKey    + 
												"-container-"  + 
												container      + 
												"-pal-"        + 
												event.pal      + 
												"-avv-"        + 
												event.avv	    +
												"-scom-"	    +
												bet.scomSogei  +
												"_"			+
												bet.handicap   +
												"-draw-"       +
												bet.draw;
								
								let playabilityIssue = null;
								if(container === 'multibets' && (bet.minPlError || bet.maxPlError) ){
									let minPl = bet.minPl? bet.minPl : 1;
									let maxPl = bet.maxPl? bet.maxPl : (conf.meb? conf.meb:30);
									if(minPl > 1){
										minPl --;
									}
									if(maxPl > 1){
										maxPl --;										
									}
									playabilityIssue = getLabel('playability.min_max_issue');
									playabilityIssue = playabilityIssue.replaceAll('{{MIN_SEL}}', minPl);
									playabilityIssue = playabilityIssue.replaceAll('{{MAX_SEL}}', maxPl);
								}
								if(container === 'multibets' && !playabilityIssue && bet.minOddError){
									playabilityIssue = getLabel('playability.min_odd_issue');
									playabilityIssue = playabilityIssue.replaceAll('{{MIN_ODD}}', oddToString(bet.minOddError));
								}
								
								if(container === 'singlebets' && bet.minPlError){
									let minPl = bet.minPl? bet.minPl : 1;
									if(minPl > 1){
										minPl --;
									}
									playabilityIssue = getLabel('playability.min_issue');
									playabilityIssue = playabilityIssue.replaceAll('{{MIN_SEL}}', minPl);
								}
								
								return (
										<div key={reactKey} 
											pal={event.pal} 
											avv={event.avv} 
											scom={bet.scomSogei} 
											handicap={bet.handicap} 
											draw={bet.draw} 
											className={"grid-schedina-body_quote-riga" + (bet.closed? ' opacityEventClosed' : '')}>
										
											{
												playabilityIssue  && <div className="playabilityIssue">
													{playabilityIssue}
												</div>
											}
											<div className="grid-schedina-body_quote-riga_descrizione-quota">
												<p> {bet.descBet} : <span>{bet.descDraw}</span></p>
												{
													bet.updated != null &&(
														<span className={"variationDesc grassetto " + (bet.updated === 'increased'? ' verde':' rosso')}>{getLabel('carrello.event.odds_variation')}</span>
													)
												}
											</div>
											
											{
												!betslipContext.isBetBuilder() && 
												<div className="grid-schedina-body_quote-riga_valore-quota">
													<p className={"no-ellipsis" + (bet.updated != null? (bet.updated === 'increased'? ' verde':' rosso') : '')}>
														{bet.closed != null && bet.closed? getLabel('general.giocabilita_chiusa') :oddToString(bet.odd)}
														{bet.updated != null &&(
																<span className={"arrow-" + (bet.updated === 'increased'? 'up':'down')}> </span>
														)}
													</p>
												</div>			
											}
											{
												(betslipContext.isBetBuilder() || container === 'systembets') && bets.length > 1 &&(
													<button onClick={() => deleteSelection(bet.scomSogei, bet.handicap, bet.draw, false)} 
															className="grid-schedina-body_quote-riga_elimna-quota grid-schedina_bottone-generico">
														<i className="fas fa-times"></i>
													</button>
												)
											}
										</div>
								)
							})
						}
					</div>	
				</div>
			</div>
		    {/* [INCREMENTATORE PUNTATA] */}
		    { tabSingle && 
		    	(
		    			<AmountBetslipForm container={container} 
		    							   linkedElement={idElement} 
		    							   couponKey={couponKey} 
		    							   isEventForm={true} 
		    							   pal={event.pal} 
		    			 				   avv={event.avv}
		    							   scomSogei={event.bets[0].scomSogei}
		    							   handicap={event.bets[0].handicap}
		    							   draw={event.bets[0].draw}/>
		    	)
		    }
		</div>
	</>
}

export default EventCoupon;